<template>
	<div :style="{
		minHeight: equipment == 'pc'?'500px':'100vh'
	}" style="user-select:text;width: 100%;background-color: #fff;margin-top: 20px;font-size: 14px;">
		<el-form label-position="top" :model="form" :rules="rules" ref="ruleForm" label-width="100px"
			class="demo-ruleForm">
			<div>
				<!-- <div>旧密码</div> -->
				<el-form-item :label="$t('h.oldPassword')" prop="old_password">
					<el-input show-password style="margin-top: 10px;" v-model="form.old_password" :placeholder="$t('h.oldPassword')"></el-input>
				</el-form-item>
			</div>
			<div style="margin-top: 20px;">
				<!-- <div>新密码</div> -->
				<el-form-item :label="$t('h.newPassword')" prop="new_password">
					<el-input show-password style="margin-top: 10px;" v-model="form.new_password" :placeholder="$t('h.newPassword')"></el-input>
				</el-form-item>
			</div>
			<div style="margin-top: 20px;">
				<!-- <div>确认新密码</div> -->
				<el-form-item :label="$t('h.confirmNewPassword')" prop="new_password_confirmation">
					<el-input show-password style="margin-top: 10px;" v-model="form.new_password_confirmation"
						:placeholder="$t('h.confirmNewPassword')"></el-input>
				</el-form-item>
			</div>
		</el-form>
		<el-button class="btn-ok" style="background-color: #000;border: solid 1px #000;margin-top: 20px;width: 40%;"
			type="primary" @click="submit">{{$t('h.confirm')}}</el-button>
	</div>
</template>

<script>
	import {
		getaccountUpdatepassword
	} from '../../../../api/all.js'
	export default {
		props: {
			equipment: {
				type: String,
				default: "pc"
			},
			localPageData: {
				type: Object,
				default: () => {
					return {}
				}
			},
			userInfo: {
				type: Object,
				default: () => {
					return {}
				}
			},

		},
		data() {
			return {
				rules: {
					old_password: [{
						required: true,
						message: '请输入旧密码',
						trigger: 'change'
					}],
					new_password: [{
						required: true,
						message: '请输入新密码',
						trigger: 'change'
					}],
					new_password_confirmation: [{
						required: true,
						message: '请输入确认新密码',
						trigger: 'change'
					}],
				},
				form: {
					old_password: "",
					new_password: "",
					new_password_confirmation: ""
				}
			}
		},
		methods: {
			async submit() {
				this.$refs['ruleForm'].validate(async (valid) => {
					if (valid) {
						try {
							this.loading = true
							await getaccountUpdatepassword(this.form)
							this.loading = false
						} catch (e) {
							this.loading = false
						}
					} else {
						return false;
					}
				});

			}
		}

	}
</script>

<style lang="scss" scoped>
	.btn-ok:hover {
		background-color: #000;
		color: #fff;
		border: solid 1px #000;
	}

	.btn-ok:focus {
		background-color: #000;
		color: #fff;
		border: solid 1px #000;
	}
</style>